import * as React from 'react';

const getWidth = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return window.innerWidth || document?.documentElement?.clientWidth || document?.body?.clientWidth;
};
/**
 * React Hook that detects window resizing
 * @returns width
 * @example
 * ```javascript
 * const width = useWindowSize()
 * ```
 */
const useWindowSize = () => {
    const [width, setWidth] = React.useState(getWidth());
    React.useEffect(() => {
        let timeoutId = 0;
        const resizeListener = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => setWidth(getWidth()), 150);
        };
        const loadListener = () => {
            setWidth(getWidth());
        };
        window.addEventListener('resize', resizeListener);
        window.addEventListener('load', loadListener);
        return () => {
            window.removeEventListener('resize', resizeListener);
            window.removeEventListener('load', loadListener);
        };
    }, []);
    return width;
};

export { useWindowSize };
//# sourceMappingURL=useWindowSize.js.map
